module.exports = __webpack_public_path__ + "static/kw51_fullpage-b282c9af15dc31438d16a3ce027bdf5f.jpg";